import { t } from 'frontend/js/modules/infra/i18n';
import { validatePromoId } from '../../validations/promo-id';
import { validateAudiences } from '../../validations/audiences';
import { validateSchedule } from '../../validations/schedule';
import { validate, setErrorsFromValidationResults } from '../../validations/validate';
import { showNotification } from '../../../../../../app/common/helpers/notifications';
export var validateStep = function (params) {
    var validationResults = validate(params, [validatePromoId, validateAudiences, validateSchedule]);
    setErrorsFromValidationResults({ store: params.store, validationResults: validationResults });
    var hasAudienceError = validationResults.errors.some(function (error) { return error.field === 'audiences'; });
    if (hasAudienceError) {
        showNotification({
            title: t('engage:campaign_builder.validation.select_audience_title'),
            message: t('engage:campaign_builder.validation.select_audience_message'),
            level: 'error',
        });
    }
    return validationResults.isValid;
};
